import { useState, useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { URL, ADMIN } from "../../../../lib/lib.js";
import "./component.css";

const Component = ({componentTitle}) => {
  
  const [categories, setCategories] = useState([]);
  const navigate = useNavigate();
  const { id } = useParams();

  const [formData, setFormData] = useState({
    name: '',
    categoryId: '',
    mrp: '',
    confirmPrice: '',
    stockQuantity: '',
    description: '',
    brand: '',
    tags: '',
    availability: 'inStock',
    images: [],
  });


  // Fetch user data if editing (for pre-filling the form)
  useEffect(() => {
    const getUserDetails = async () => {
      try {
        const response = await fetch(URL + ADMIN.product_view, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({id}),
          credentials: 'include'
        });
        const result = await response.json();
        const data = result.data;
        if (data) {
          setFormData({
            name: data.name || '',
            categoryId: data.categoryId?._id || '',
            mrp: data.mrp || '',
            confirmPrice: data.confirmPrice || '',
            stockQuantity: data.stockQuantity || '',
            description: data.description || '',
            brand: data.brand || '',
            tags: data.tags || '',
            availability: data.availability || '',
            images: data.images || [],
          });
        }
      } catch (err) {
        console.error("Failed to fetch user details:", err);
      }
    };
  
    if (id) {
      getUserDetails();
    }
  }, [id]);
  
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleImageUpload = (e) => {
    const newFiles = Array.from(e.target.files);
    const total = formData.images.length + newFiles.length;

    if (total > 5) {
      alert("Max 5 images allowed.");
      return;
    }

    setFormData((prev) => ({
      ...prev,
      images: [...prev.images, ...newFiles]
    }));
  };


  // const handleImageUpload = (e) => {
  //   const files = Array.from(e.target.files);
  //   if (files.length <= 5) {
  //     setFormData({ ...formData, images: files });
  //   } else {
  //     alert('You can only upload a maximum of 5 images');
  //   }
  // };

  useEffect(() => { fetchCategories(); }, []);

  const fetchCategories = async () => {
    try {
      const response = await fetch(URL + ADMIN.category_view, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: 'include'
      });
      const data = await response.json();
      setCategories(data.data);
    } catch (error) {
      console.error('Error fetching categories:', error);
    }
  };


  // Form submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    
    const dataToSend = new FormData();
    
    for (const key in formData) {
      if (formData[key] && key !== "images") { 
        dataToSend.append(key, formData[key]);
      }
    }

    if (formData.images) {
      if (formData.images && formData.images.length > 0) {
        formData.images.forEach((image) => {
          dataToSend.append("images", image);
        });
      }
    }

    if (id) {
      dataToSend.append("id", id);
    }

    try {
      const url = URL + (id ? ADMIN.product_update : ADMIN.product_create);

      const request = await fetch(url, {
        method: "POST",
        body: dataToSend,
        credentials: "include",
      });

      if (request.ok) {
        const response = await request.json();
        console.log(response);
        alert(response.message); 
        navigate('/admin/product'); 
      } else {
        const errorResponse = await request.json();
        alert(errorResponse.message || "Something went wrong.");
      }
    } catch (error) {
      console.error("Error:", error);
      alert("An error occurred. Please try again later.");
    }
  };

  return (
    <div id="adduser" className="container-fluid">
      <div className="row profile-my_flx_profile_up">
        <div className="col-xl-2 col-lg-3 col-md-2 profile-pro1 profile-admin">
          <Link to="/admin/product">
            <button className="profile-back">
              <i className="ri-arrow-left-s-line profile-lefticon"></i>
            </button>
          </Link>
        </div>
        <div className="col-xl-8 col-lg-6 col-md-8">
          <div className="profile-my_form_signup_profile">

             <form onSubmit={(e) => handleSubmit(e, formData)}>
              <p className="profile-login_head">{id ? 'Edit' : 'Create'} Product</p>

              <h5><b>Basic Product Details</b></h5>
              <div className="mb-3 m-2 row">
                <div className="col-md-6 p-2">
                  <label className="form-label profile-user_label">Product Name</label>
                  <input type="text" name="name" value={formData.name} onChange={handleChange} className="form-control" placeholder="Enter Product Name" required />
                </div>

                {/* <div className="col-md-6 p-2">
                  <label className="form-label profile-user_label">Category</label>
                  <input type="text" name="category" value={formData.category} onChange={handleChange} className="form-control" placeholder="Enter Product Category" required />
                </div> */}

                <div className="col-md-6 p-2">
                  <label className="form-label profile-user_label">Category</label>
                  <select name="categoryId" value={formData.categoryId} onChange={handleChange} className="form-control" required>
                    <option value="">Select Category</option>
                    {categories.map((category) => (
                      <option key={category.id} value={category._id}>{category.name}</option>
                    ))}
                  </select>
                </div>


                <div className="col-md-6 p-2">
                  <label className="form-label profile-user_label">MRP (Maximum Retail Price)</label>
                  <input type="number" name="mrp" value={formData.mrp} onChange={handleChange} className="form-control" placeholder="Enter MRP" required />
                </div>

                <div className="col-md-6 p-2">
                  <label className="form-label profile-user_label">Confirm Price</label>
                  <input type="number" name="confirmPrice" value={formData.confirmPrice} onChange={handleChange} className="form-control" placeholder="Enter Confirm Price" required />
                </div>

                <div className="col-md-12 p-2">
                  <label className="form-label profile-user_label">Product Description</label>
                  <textarea name="description" value={formData.description} onChange={handleChange} className="form-control" placeholder="Enter Product Description" rows="4" required />
                </div>

                <div className="col-md-6 p-2">
                  <label className="form-label profile-user_label">Brand/Manufacturer</label>
                  <input type="text" name="brand" value={formData.brand} onChange={handleChange} className="form-control" placeholder="Enter Brand/Manufacturer" required />
                </div>

                <div className="col-md-6 p-2">
                  <label className="form-label profile-user_label">Tags (Comma Separated)</label>
                  <input type="text" name="tags" value={formData.tags} onChange={handleChange} className="form-control" placeholder="Enter Tags" />
                </div>

                <div className="col-md-12 p-2">
                  <label className="form-label profile-user_label">Product Images (Max 5)</label>
                  <input type="file" name="images" multiple accept="image/*" onChange={handleImageUpload} className="form-control" required={!id} />
                  {formData.images && formData.images.length > 0 && (
                    <div className="image-preview mt-2">
                      {formData.images.map((img, idx) => {
                        const isFile = img instanceof File;
                        const src = isFile ? window.URL.createObjectURL(img) : `${URL}/uploads/${img}`; 
                        return ( <img key={idx} src={src} alt={`img-${idx}`} style={{ maxWidth: '100px', marginRight: '8px' }} /> );
                      })}
                    </div>
                  )}
                  {formData.images && formData.images.length > 5 && ( <small className="text-danger">You can upload a maximum of 5 images.</small> )}
                </div>
              </div>

              <h5><b>Additional Product Details</b></h5>
              <div className="m-2 mb-3 row">
                <div className="col-md-6 p-2">
                  <label className="form-label profile-user_label">Stock Quantity</label>
                  <input type="number" name="stockQuantity" value={formData.stockQuantity} onChange={handleChange} className="form-control" placeholder="Enter Stock Quantity" required />
                </div>

                <div className="col-md-6 p-2">
                  <label className="form-label profile-user_label">Availability</label>
                  <select name="availability" value={formData.availability} onChange={handleChange} className="form-control" required >
                    <option value="inStock">In Stock</option>
                    <option value="outOfStock">Out of Stock</option>
                  </select>
                </div>
              </div>

              <button type="submit" className="profile-submit_bot1">{id ? "Update" : "Create"} Product</button>
            </form>

          </div>
        </div>
        <div className="col-xl-2 col-lg-3 col-md-2"></div>
      </div>
    </div>
  );
};

export default Component;
